<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { fetchQrCode } from '@/api/apiService.ts';
import LanguageBar from '@/components/domains/chat/common/LanguageBar.vue';
import InfoIcon from '@/components/icons/IconInfo.vue';
import { useAllTranslations } from '@/static/messageBylanguages.js';

const code = ref('');
const errorMessage = ref('');
const requesting = ref(false);
const translations = useAllTranslations();

const route = useRoute();
const router = useRouter();

const validateInput = () => {
  // 숫자와 영어만 포함되어 있는지 확인하는 정규 표현식
  const regex = /^[a-zA-Z0-9]*$/;
  if (!regex.test(code.value)) {
    errorMessage.value = translations.intro_wrong_code.value;
  } else {
    errorMessage.value = '';
  }
};

const handleCode = async () => {
  requesting.value = true;
  if (code.value.length < 5) {
    errorMessage.value = translations.intro_wrong_code.value;
    requesting.value = false;
    return;
  }

  const response = await fetchQrCode(code.value);
  if (response.success) {
    router.push({ name: 'chat-entrance', params: { code: code.value } });
  } else {
    errorMessage.value = translations.intro_wrong_code.value;
  }
  requesting.value = false;
};
</script>

<template>
  <div class="container">
    <RouterLink to="/admin-login"> </RouterLink>
    <div class="bottom-part">
      <div class="login-container">
        <img src="/images/logo-sconchat-full.png" alt="sconchat-logo" class="sconchat-logo" />
        <h4>{{ $t('intro_write_code_to_start') }}</h4>
        <div class="wrapper-input">
          <input
            type="text"
            :placeholder="$t('intro_write_code')"
            v-model="code"
            :class="{ 'input-error': errorMessage }"
            @keyup.enter="handleCode"
            @input="validateInput"
            maxlength="6"
          />

          <div v-if="errorMessage" class="error-message">
            <InfoIcon class="icon-error" />
            <p class="small">{{ errorMessage }}</p>
          </div>
        </div>

        <button class="button-primary button-full-width" @click="handleCode">
          {{ $t('entrance') }}
        </button>
        <LanguageBar class="language-bar" />
        <!--        <div class="line">-->
        <!--          <p class="small">-->
        <!--            로그인에 문제가 있을 시에는 관리자에게 문의하여 주세요.-->
        <!--          </p>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
}

.logo {
  display: flex;
  justify-content: left;
  align-items: left;
  gap: 0.5rem;
}

.sconchat-logo {
  height: 2rem;
  margin-bottom: 1rem;
}

.wrapper-input {
  width: 100%;
  margin: 0.5rem 0 1rem 0;
}

.login-container {
  width: 100%;
  max-width: 25rem;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-top: 3rem;
}

.login-container-head {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bottom-part {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-bg-uploaded {
  width: 100%;
  flex-grow: 1;
  max-height: 100%;
  background-color: var(--color-gray-10);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.input-error {
  border-color: var(--color-red);
  box-shadow: none;
}

.error-message {
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  color: var(--color-red);
  margin-top: 0.25rem;
  gap: 0.25rem;
}

.icon-error {
  width: 1rem;
  height: 1rem;
  fill: var(--error);
}

.language-bar {
  margin-top: 0.5rem;
}

@media (min-width: 768px) {
  .container {
    width: 100%;
    height: 100dvh;
    background: var(--surface-background);
    align-items: center;
  }

  .logo {
    justify-content: flex-start;
  }

  .login-container {
    width: 25rem;
    align-items: baseline;
    margin: 0 auto;
    margin-bottom: 5rem;
    padding: 2rem;
    border-radius: 8px;
    background-color: var(--surface-default);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.08);
  }

  .bottom-part {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
